const serialKey = 'mobile-counter-pos-serial-receive-data';

function setSerialData(data) {
	localStorage.setItem(serialKey, JSON.stringify(data));
}

function getSerialData() {
	const serialData = localStorage.getItem(serialKey);

	if (serialData) {
		const data = JSON.parse(serialData);

		return data;
	}

	return [];
}

export default {
	setSerialData,
	getSerialData,
};